import type { Template } from "@/types";

export const PO_01_H0_V1: Template[] = [
    {
        id: "po-01-h0v1-01",
        name: "PO 01 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 783, y: 88, width: 494, height: 741, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-01-h0v1-02",
        name: "PO 02 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 734, y: 42, width: 593, height: 833, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-01-h0v1-03",
        name: "PO 03 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 440, y: 88, width: 494, height: 741, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-04",
        name: "PO 04 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 47, y: 42, width: 593, height: 833, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-05",
        name: "PO 05 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 97, y: 88, width: 494, height: 741, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-06",
        name: "PO 06 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 687, y: 0, width: 686, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-07",
        name: "PO 07 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 687, y: 0, width: 601, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-08",
        name: "PO 08 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 686, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h0v1-09",
        name: "PO 09 - H0V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h0_v1_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 86, y: 0, width: 601, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },
];

